import { Component, OnInit, OnChanges, SimpleChanges, Input, Output, EventEmitter } from '@angular/core';
import * as moment from 'moment';
import { HttpClient } from '@angular/common/http';
import { CommonUtil } from '../../../../../shared/services/utility/common.service';
import { PlinksDashboardService } from '../plinks-dashboard.service';
import { CommonDataService } from '../../../../../shared/services/common-data.service'
import * as _ from 'underscore';

@Component({
	selector: 'app-plink-events',
	templateUrl: './plink-events.component.html',
	styleUrls: ['./plink-events.component.css']
})
export class PlinkEventsComponent implements OnInit, OnChanges {

	@Input() device: any = {};
	@Input() deviceType: string = 'plink';
	@Input() date: {
		fromDate: any,
		toDate: any
	} = {
		fromDate: null,
		toDate: null
	};

	@Output() updateAppearanceElementsFlags = new EventEmitter<any>(true);
	settings: any ={
		height: "550"
	}

	gridColumns: any;
	gridData: any[] = [];
	loading: boolean = false;

	constructor(
		private httpClient: HttpClient,
		private commonUtil: CommonUtil,
		private plinksDashboardService: PlinksDashboardService,
		private commonData: CommonDataService
	) {
		this.gridColumns = [
			{headerName: 'ID', field: 'sid', width: 80,},
			{headerName: 'Start Time', field: 'startTimeFormatted', width: 180, type: 'string'},
			{headerName: 'Duration', field: 'durationFormatted', width: 100},
			// {headerName: "Device ID", field: "chargerId", width: 90},
			{headerName: "V1 RMS Voltage (V)", field: "phaseAVoltage", width: 160},
			{headerName: "V2 RMS Voltage (V)", field: "phaseBVoltage", width: 160},
			{headerName: "V3 RMA Voltage (V)", field: "phaseCVoltage", width: 160},
			{headerName: "l1 RMS (A)", field: "phaseACurrent", width: 130},
			{headerName: "l2 RMS (A)", field: "phaseBCurrent", width: 130},
			{headerName: "l3 RMS (A)", field: "phaseCCurrent", width: 130},
			{headerName: "Total Active Energy (kW)", field: "totalActiveEnergyFormatted", width: 190},
			{headerName: "Total Billable Energy (kWh)", field: "totalBillEnergyFormatted", width: 204},
			{headerName: "Event Type", field: "eventFlagText", width: 200, floatingFilterComponent: "dropDownFilterComponent", floatingFilterComponentParams: {filterOptionType: 'contains', dropDownOptions: [{label: '', value: ''},{label: 'Idle', value: 'Idle'}, {label: 'Connected', value: 'Connected'}, {label: 'AC-OUT', value: 'AC-OUT'}, {label: 'Midnight Split', value: 'Midnight Split'}, {label: 'Time Change Split', value: 'Time Change Split'}]},},
			{headerName: "Zone", field: "zoneText", width: 280},
			{headerName: "Exit Status", field: "exitStatusText", width: 180, floatingFilterComponent: "dropDownFilterComponent", floatingFilterComponentParams: {dropDownOptions: [{label: '', value: ''},{label: 'Disconnect', value: 'Disconnect'}, {label: 'Stop', value: 'Stop'}, {label: 'Latching Fault', value: 'Latching Fault'}, {label: 'Non-Latching Fault', value: 'Non-Latching Fault'}, {label: 'AUX Relay Failure', value: 'AUX Relay Failure'}]},},
			{headerName: "Fault Error Code", field: "faultErrorCodeText", width: 350, floatingFilterComponent: "dropDownFilterComponent", floatingFilterComponentParams: {filterOptionType: 'contains', dropDownOptions: [{label: '', value: ''},{label: 'Fault Latching', value: 'Fault Latching'}, {label: 'Fault Non-Latching', value: 'Fault Non-Latching'}, {label: 'Over Voltage', value: 'Over Voltage'}, {label: 'Under Voltage', value: 'Under Voltage'}, {label: 'Over Current', value: 'Over Current'}, {label: 'Under Current', value: 'Under Current'}, {label: 'Over Frequency', value: 'Over Frequency'}, {label: 'Under Frequency', value: 'Under Frequency'}, {label: 'No Fault', value: 'No Fault'}]},},
			{headerName: "Fault Relay Code", field: "faultRelayCodeText", width: 180, floatingFilterComponent: "dropDownFilterComponent", floatingFilterComponentParams: {dropDownOptions: [{label: '', value: ''},{label: 'Fault Relay Aux Bad', value: 'Fault Relay Aux Bad'}, {label: 'No Relay Fault', value: 'No Relay Fault'}]},},
			{headerName: "Version", field: "ver", width: 83},
			{headerName: 'End Time', field: 'endTime', width: 180}
		];
	}

	ngOnInit() {
		this.updateAppearanceElementsFlags.emit({
			addNoteEnabled: false,
			pageHasFilterByDate: true,
			pageHasBattviewTags: true,
			hasResetPLC: false,
			pageHasManageBtn: true,
			pageHasTimesInfo: true,
		});

		// Try to load events if we already have data
		this.getEventsData();
	}

	ngOnChanges(changes: SimpleChanges) {
		// Trigger API call when either device or date changes
		if ((changes['device'] && changes['device'].currentValue) ||
		    (changes['date'] && changes['date'].currentValue)) {
			this.getEventsData();
		}
	}

	onDeviceChanged(device) {
		this.device = device;
		this.getEventsData();
	}

	onDatesUpdated(date) {
		this.date = date;
		this.getEventsData();
	}


	// Get Events Data
	getEventsData(){
		this.loading = true;
		this.gridData = [];

		const plinkID = this.device?.deviceid || this.device?.id;

		// Calculate date range for filtering
		let fromDate = new Date(this.date.fromDate);
		let toDate = new Date(this.date.toDate);
		fromDate.setHours(0,0,0,0);
		toDate.setHours(23,59,59,999); // Set to midnight 


		this.plinksDashboardService?.getPolarLinkEvents(plinkID, fromDate, toDate, 0).subscribe((result: any) => {
			if(result && result.res && result.res?.Records && result.res.Records.length > 0){
				result.res.Records.forEach((record:any) => {
					// Format Event Flag
					if(record.eventFlagName != null){
						if(Array.isArray(record.eventFlagName)){
							record.eventFlagText = "";
							record.eventFlagName.forEach((eventType: number, idx:number) => {
								this.eventTypeSwitch(eventType, record, idx);
								});
						}else{
							record.eventFlagText = "";
							this.eventTypeSwitch(record.eventFlagName, record, null);
						}
					}

					// Format Exit Status
					if(record.exitStatusName != null){
						switch(record.exitStatusName){
							case 1:
								record.exitStatusText = 'Disconnect';
								break;
							case 2: 
								record.exitStatusText = 'Stop';
								break;
							case 4: 
								record.exitStatusText = 'Latching Fault';
								break;
							case 8:
								record.exitStatusText = 'Non-Latching Fault';
								break;
							case 16: 
								record.exitStatusText = 'AUX Relay Failure'
								break;
							default:
								record.exitStatusText = 'N/A';
						}
					}

					//Format Fault Error Code
					if(record.faultErrorCodeName != null){
						if(Array.isArray(record.faultErrorCodeName)){
							if(record.faultErrorCodeName.length == 0) record.faultErrorCodeText = 'No Fault';
							else{
								record.faultErrorCodeText = "";
								record.faultErrorCodeName.forEach((errorCode: number, idx:number) => {
									this.faultErrorCodeSwitch(errorCode, record, idx);
								});
							}
						}else{
							record.faultErrorCodeText = "";
							this.faultErrorCodeSwitch(record.faultErrorCodeName, record, null);
						}
					}

					//Format Fault Error Code
					if(record.faultRelayCodeName != null){
						switch(record.faultRelayCodeName){
							case 1:
								record.faultRelayCodeText = 'Fault Relay Aux Bad';
								break;
							// case 1:
							// case 2:
							// case 3:
							// case 4:
							// case 5:
							// case 6:
							// case 7:
							// 	record.faultRelayCodeText = `Fault Reserved Bit${record.faultRelayCode}`;
								// break;
							default:
								record.faultRelayCodeText = "No Relay Fault";
						}
					}

					//Format Duration
					if(record.dur != null){
						const duration = moment.duration(record.dur, 'seconds');
						const hours = Math.floor(duration.asHours());
						const minutes = duration.minutes();
						const secs = duration.seconds();
						record.durationFormatted = [String(hours).padStart(2, "0"), String(minutes).padStart(2, '0'), String(secs).padStart(2, '0')].join(':');
					}

					// Need to extract timezone and daylight saving 
					if(record.zone){
						// Get Daylight savings
						record.getDayLightSavings = record.zone & 0x80;
						if(record.getDayLightSavings === 0) record.getDayLightSavings = false;
						else record.getDayLightSavings = true;

						record.zone = record.zone & 0x0f;
						let zoneObj = this.commonData.TimeZonesMenu[record.zone - 1];
						record.zoneText = zoneObj?.display_name || "";
					}



					//

					// Format start time
					if (record.startTime) {
						
						 function formatTimestampToYMDHMS(unixSeconds) {
							const date = new Date(unixSeconds * 1000);

							const yyyy = date.getUTCFullYear();
							const mm = String(date.getUTCMonth() + 1).padStart(2, '0'); // Months are 0-based
							const dd = String(date.getUTCDate()).padStart(2, '0');

							const HH = String(date.getUTCHours()).padStart(2, '0');
							const MM = String(date.getUTCMinutes()).padStart(2, '0');
							const SS = String(date.getUTCSeconds()).padStart(2, '0');

							return `${yyyy}-${mm}-${dd} ${HH}:${MM}:${SS}`;
						}
						const startTime = this.commonUtil.getZoneTimestampFromUTC(record.zone, record.startTime, record.getDayLightSavings);
						record.startTimeFormatted = formatTimestampToYMDHMS(startTime);

						//Format endt ime
						record.endTime = moment(record.startTimeFormatted, 'YYYY-MM-DD HH:mm:ss').add(record.dur, 'seconds').format('YYYY-MM-DD HH:mm:ss');
					} 

					if(record.totalBillEnergy){
						record.totalBillEnergyFormatted = record.totalBillEnergy.toFixed(3);
					}

					if(record.totalActiveEnergy){
						record.totalActiveEnergyFormatted = record.totalActiveEnergy.toFixed(6);
					}
					this.gridData.push(record);
				});

				//Sort Data
				this.gridData = this.gridData.sort((a: any,b: any) => b.sid - a.sid);
				this.loading = false;
			}else{
				this.loading = false;
			}
		});
	}

	faultErrorCodeSwitch(errorCode: number, record: any,  idx: number | null){
		switch(errorCode){
			case 1:
				record.faultErrorCodeText += 'Fault Latching';
				break;
			case 2:
				record.faultErrorCodeText += "Fault Non-Latching";
				break;
			case 4:
				record.faultErrorCodeText += "Over Voltage";
				break;
			case 8:
				record.faultErrorCodeText += "Under Voltage";
				break;
			case 16:
				record.faultErrorCodeText += "Over Current";
				break;
			case 32: 
				record.faultErrorCodeText += "Under Current";
				break;
			case 64:
				record.faultErrorCodeText += "Over Frequency";
				break;
			case 128:
				record.faultErrorCodeText += "Under Frequency";
				break;
			default:
				record.faultErrorCodeText += "No Fault";
		}

		if(idx !== null && idx+1 < record.faultErrorCodeName.length){
			record.faultErrorCodeText += ', ';
		}
	}

	eventTypeSwitch(eventType: number, record: any,  idx: number | null){
		switch(eventType){
			case 1: 
				record.eventFlagText += 'Idle';
				break;
			case 2: 
				record.eventFlagText += 'Connected';
				break;
			case 4:
				record.eventFlagText += 'AC-OUT';
				break;
			case 64:
				record.eventFlagText += 'Midnight Split';
				break;
			case 128:
				record.eventFlagText += 'Time Change Split';
				break;
			default:
				break;
		}

		if(idx !== null && idx+1 < record.eventFlagName.length){
			record.eventFlagText += ', ';
		}
	}

	/**
	 * Check if event falls within the selected date range
	 */
	private isEventInDateRange(eventDate: Date, dateRange: {fromDate: Date, toDate: Date}): boolean {
		const eventTime = eventDate.getTime();
		const fromTime = dateRange.fromDate.getTime();
		const toTime = dateRange.toDate.getTime() + (24 * 60 * 60 * 1000) - 1; // End of day

		return eventTime >= fromTime && eventTime <= toTime;
	}

	getTotalItems(): number {
		return this.gridData ? this.gridData.length : 0;
	}
}
